import React, { useState } from "react";
import { formStyles as s, downloadBtnStyle, DownloadIcon, requiredInput } from "./formStyles";



const OC_ROWS = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];

const VendorCreationForm = ({ pdfUrl = "/static/pdffilters/SNL-Vendor-Creation-form.pdf" }) => {
  const [form, setForm] = useState({
    // Vendor Type
    vendorCustomer: false,
    vendorSupplier: false,
    // Company Details
    companyName: "",
    tradingName: "",
    abn: "",
    accountsContactName: "",
    phone: "",
    email: "",
    streetAddress: "",
    suburb: "",
    state: "",
    postcode: "",
    // Billing Details
    companyName2: "",
    tradingName2: "",
    abn2: "",
    contactPhone: "",
    accountsContact: "",
    email2: "",
    streetAddress2: "",
    suburb2: "",
    state2: "",
    postcode2: "",
    // OC Rows 1-12 (Total is calculated from Services + Consumables + Periodicals + Special)
    oc1Services: "", oc1Consumables: "", oc1Periodicals: "", oc1Special: "",
    oc2Services: "", oc2Consumables: "", oc2Periodicals: "", oc2Special: "",
    oc3Services: "", oc3Consumables: "", oc3Periodicals: "", oc3Special: "",
    oc4Services: "", oc4Consumables: "", oc4Periodicals: "", oc4Special: "",
    oc5Services: "", oc5Consumables: "", oc5Periodicals: "", oc5Special: "",
    oc6Services: "", oc6Consumables: "", oc6Periodicals: "", oc6Special: "",
    oc7Services: "", oc7Consumables: "", oc7Periodicals: "", oc7Special: "",
    oc8Services: "", oc8Consumables: "", oc8Periodicals: "", oc8Special: "",
    oc9Services: "", oc9Consumables: "", oc9Periodicals: "", oc9Special: "",
    oc10Services: "", oc10Consumables: "", oc10Periodicals: "", oc10Special: "",
    oc11Services: "", oc11Consumables: "", oc11Periodicals: "", oc11Special: "",
    oc12Services: "", oc12Consumables: "", oc12Periodicals: "", oc12Special: "",
    // EOM
    eomInvoice: "",
  });

  const [downloading, setDownloading] = useState(false);
  const [error, setError] = useState(null);
  const [sameAsBilling, setSameAsBilling] = useState(false);

  const u = (field, value) => setForm((p) => ({ ...p, [field]: value }));

  const handleSameAsBilling = (checked) => {
    setSameAsBilling(checked);
    if (checked) {
      setForm((p) => ({
        ...p,
        companyName2: p.companyName,
        tradingName2: p.tradingName,
        abn2: p.abn,
        contactPhone: p.phone,
        accountsContact: p.accountsContactName,
        email2: p.email,
        streetAddress2: p.streetAddress,
        suburb2: p.suburb,
        state2: p.state,
        postcode2: p.postcode,
      }));
    }
  };

  const isValid = form.companyName.trim() && form.abn.trim() && (form.vendorCustomer || form.vendorSupplier);

  // Calculate row total: sum of 4 fields across a single OC row
  const calcRowTotal = (num) => {
    const services = parseFloat(form[`oc${num}Services`]) || 0;
    const consumables = parseFloat(form[`oc${num}Consumables`]) || 0;
    const periodicals = parseFloat(form[`oc${num}Periodicals`]) || 0;
    const special = parseFloat(form[`oc${num}Special`]) || 0;
    return ((services + consumables + periodicals + special)*100).toFixed(2);
  };

  // Calculate column total: sum of a single field across all 12 OC rows
  const calcColTotal = (field) => {
    let sum = 0;
    for (let i = 1; i <= 12; i++) {
      const val = parseFloat(form[`oc${i}${field}`]) || 0;
      sum += val;
    }
    return (sum*100).toFixed(2);
  };

  // Calculate grand total: sum of all 12 row totals
  const calcGrandTotal = () => {
    let sum = 0;
    for (let i = 1; i <= 12; i++) {
      sum += parseFloat(calcRowTotal(i)) || 0;
    }
    return sum.toFixed(2);
  };

  const handleDownload = async () => {
    setDownloading(true);
    setError(null);
    try {
      const { PDFDocument } = await import("pdf-lib");
      const pdfBytes = await fetch(pdfUrl).then((r) => {
        if (!r.ok) throw new Error("Could not load PDF template");
        return r.arrayBuffer();
      });
      const pdfDoc = await PDFDocument.load(pdfBytes);
      pdfDoc.setTitle(`Vendor Creation Form - ${form.companyName}`);
      const f = pdfDoc.getForm();

      const setText = (name, val) => {
        try {
          const field = f.getTextField(name);
          field.setFontSize(12);
          field.setText(val || "");
        } catch (_) {}
      };

      const setCheck = (name, checked) => {
        try {
          const cb = f.getCheckBox(name);
          if (checked) cb.check(); else cb.uncheck();
        } catch (_) {}
      };

      // ── Vendor Type ──
      setCheck("Custckbox", form.vendorCustomer);
      setCheck("Suppckbox", form.vendorSupplier);

      // ── Company Details ──
      setText("CompanyName", form.companyName);
      setText("TradingNameapplicable", form.tradingName);
      setText("ABN", form.abn);
      setText("AccountsContactName", form.accountsContactName);
      setText("Phone", form.phone);
      setText("Email", form.email);
      setText("Street Address for payment remittance", form.streetAddress);
      setText("Suburb", form.suburb);
      setText("State", form.state);
      setText("Postcode", form.postcode);

      // ── Billing Details ──
      setText("CompanyName_2", form.companyName2);
      setText("TradingNameapplicable_2", form.tradingName2);
      setText("ABN_2", form.abn2);
      setText("ContactPhone", form.contactPhone);
      setText("AccountsContact", form.accountsContact);
      setText("Email_2", form.email2);
      setText("StreetAddresspaymentremittance_2", form.streetAddress2);
      setText("Suburb_2", form.suburb2);
      setText("State_2", form.state2);
      setText("Postcode_2", form.postcode2);

      // ── OC Rows 1-12 ──
      setText("Cleaning Total OC1", calcRowTotal(1));
      setText("Cleaning ServicesOC1", form.oc1Services);
      setText("ConsumablesOC1", form.oc1Consumables);
      setText("PeriodicalsOC1", form.oc1Periodicals);
      setText("Special RequestOC1", form.oc1Special);

      setText("Cleaning Total OC2", calcRowTotal(2));
      setText("Cleaning ServicesOC2", form.oc2Services);
      setText("ConsumablesOC2", form.oc2Consumables);
      setText("PeriodicalsOC2", form.oc2Periodicals);
      setText("Special RequestOC2", form.oc2Special);

      setText("Cleaning Total OC3", calcRowTotal(3));
      setText("Cleaning ServicesOC3", form.oc3Services);
      setText("ConsumablesOC3", form.oc3Consumables);
      setText("PeriodicalsOC3", form.oc3Periodicals);
      setText("Special RequestOC3", form.oc3Special);

      setText("Cleaning Total OC4", calcRowTotal(4));
      setText("Cleaning ServicesOC4", form.oc4Services);
      setText("ConsumablesOC4", form.oc4Consumables);
      setText("PeriodicalsOC4", form.oc4Periodicals);
      setText("Special RequestOC4", form.oc4Special);

      setText("Cleaning Total OC5", calcRowTotal(5));
      setText("Cleaning ServicesOC5", form.oc5Services);
      setText("ConsumablesOC5", form.oc5Consumables);
      setText("PeriodicalsOC5", form.oc5Periodicals);
      setText("Special RequestOC5", form.oc5Special);

      setText("Cleaning Total OC6", calcRowTotal(6));
      setText("Cleaning ServicesOC6", form.oc6Services);
      setText("ConsumablesOC6", form.oc6Consumables);
      setText("PeriodicalsOC6", form.oc6Periodicals);
      setText("Special RequestOC6", form.oc6Special);

      setText("Cleaning Total OC7", calcRowTotal(7));
      setText("Cleaning ServicesOC7", form.oc7Services);
      setText("ConsumablesOC7", form.oc7Consumables);
      setText("PeriodicalsOC7", form.oc7Periodicals);
      setText("Special RequestOC7", form.oc7Special);

      setText("Cleaning Total OC8", calcRowTotal(8));
      setText("Cleaning ServicesOC8", form.oc8Services);
      setText("ConsumablesOC8", form.oc8Consumables);
      setText("PeriodicalsOC8", form.oc8Periodicals);
      setText("Special RequestOC8", form.oc8Special);

      setText("Cleaning Total OC9", calcRowTotal(9));
      setText("Cleaning ServicesOC9", form.oc9Services);
      setText("ConsumablesOC9", form.oc9Consumables);
      setText("PeriodicalsOC9", form.oc9Periodicals);
      setText("Special RequestOC9", form.oc9Special);

      setText("Cleaning Total OC10", calcRowTotal(10));
      setText("Cleaning ServicesOC10", form.oc10Services);
      setText("ConsumablesOC10", form.oc10Consumables);
      setText("PeriodicalsOC10", form.oc10Periodicals);
      setText("Special RequestOC10", form.oc10Special);

      setText("Cleaning Total OC11", calcRowTotal(11));
      setText("Cleaning ServicesOC11", form.oc11Services);
      setText("ConsumablesOC11", form.oc11Consumables);
      setText("PeriodicalsOC11", form.oc11Periodicals);
      setText("Special RequestOC11", form.oc11Special);

      setText("Cleaning Total OC12", calcRowTotal(12));
      setText("Cleaning ServicesOC12", form.oc12Services);
      setText("ConsumablesOC12", form.oc12Consumables);
      setText("PeriodicalsOC12", form.oc12Periodicals);
      setText("Special RequestOC12", form.oc12Special);

      // ── Totals Row ──
      setText("Cleaning Total Total", calcGrandTotal());
      setText("Cleaning ServicesTotal", calcColTotal("Services"));
      setText("ConsumablesTotal", calcColTotal("Consumables"));
      setText("PeriodicalsTotal", calcColTotal("Periodicals"));
      setText("Special RequestTotal", calcColTotal("Special"));

      // ── EOM ──
      setText("EOM Invoice", form.eomInvoice);

      // ── Flatten and save ──
      f.flatten();
      const filled = await pdfDoc.save();
      const blob = new Blob([filled], { type: "application/pdf" });
      const link = document.createElement("a");
      link.href = URL.createObjectURL(blob);
      link.download = `Vendor-Creation-${form.companyName || "Form"}.pdf`;
      link.click();
      URL.revokeObjectURL(link.href);
    } catch (err) {
      console.error("PDF fill error:", err);
      setError(err.message || "Failed to generate PDF");
    } finally {
      setDownloading(false);
    }
  };

  const handleReset = () => {
    const resetOC = {};
    for (let i = 1; i <= 12; i++) {
      resetOC[`oc${i}Services`] = "";
      resetOC[`oc${i}Consumables`] = "";
      resetOC[`oc${i}Periodicals`] = "";
      resetOC[`oc${i}Special`] = "";
    }
    setForm({
      vendorCustomer: false, vendorSupplier: false,
      companyName: "", tradingName: "", abn: "",
      accountsContactName: "", phone: "", email: "",
      streetAddress: "", suburb: "", state: "", postcode: "",
      companyName2: "", tradingName2: "", abn2: "",
      contactPhone: "", accountsContact: "", email2: "",
      streetAddress2: "", suburb2: "", state2: "", postcode2: "",
      ...resetOC,
      eomInvoice: "",
    });
    setError(null);
    setSameAsBilling(false);
  };

  return (
    <div style={s.wrapper}>
      <style>{s.spinKeyframes}</style>
      <h2 style={s.title}>Vendor Creation Form</h2>
      <p style={s.subtitle}>Complete the form and download the filled PDF</p>

      {/* ── Vendor Type ── */}
      <div style={s.section}>
        <div style={s.sectionLabel}>Vendor Type *</div>
        <div style={{ display: "flex", gap: 24, marginTop: 8 }}>
          <label style={{ ...s.label, display: "flex", alignItems: "center", gap: 8, cursor: "pointer" }}>
            <input type="checkbox" checked={form.vendorCustomer} onChange={(e) => u("vendorCustomer", e.target.checked)} />
            Customer
          </label>
          <label style={{ ...s.label, display: "flex", alignItems: "center", gap: 8, cursor: "pointer" }}>
            <input type="checkbox" checked={form.vendorSupplier} onChange={(e) => u("vendorSupplier", e.target.checked)} />
            Supplier
          </label>
        </div>
      </div>

      <hr style={s.divider} />

      {/* ── Company Details ── */}
      <div style={s.section}>
        <div style={s.sectionLabel}>Company Details</div>
        <div style={s.fieldGrid2}>
          <div style={s.fieldGroup}>
            <label style={s.label}>Company Name *</label>
            <input style={requiredInput(form.companyName)} value={form.companyName} onChange={(e) => u("companyName", e.target.value)} placeholder="Company name" />
          </div>
          <div style={s.fieldGroup}>
            <label style={s.label}>Trading Name (if applicable)</label>
            <input style={s.input} value={form.tradingName} onChange={(e) => u("tradingName", e.target.value)} placeholder="Trading name" />
          </div>
          <div style={s.fieldGroup}>
            <label style={s.label}>ABN *</label>
            <input style={requiredInput(form.abn)} value={form.abn} onChange={(e) => u("abn", e.target.value)} placeholder="ABN" />
          </div>
          <div style={s.fieldGroup}>
            <label style={s.label}>Accounts Contact Name</label>
            <input style={s.input} value={form.accountsContactName} onChange={(e) => u("accountsContactName", e.target.value)} placeholder="Contact name" />
          </div>
          <div style={s.fieldGroup}>
            <label style={s.label}>Phone</label>
            <input style={s.input} value={form.phone} onChange={(e) => u("phone", e.target.value)} placeholder="Phone number" />
          </div>
          <div style={s.fieldGroup}>
            <label style={s.label}>Email</label>
            <input style={s.input} value={form.email} onChange={(e) => u("email", e.target.value)} placeholder="Email address" />
          </div>
        </div>
        <div style={{ ...s.fieldFull, marginTop: 14 }}>
          <label style={s.label}>Street Address (for payment remittance)</label>
          <input style={s.input} value={form.streetAddress} onChange={(e) => u("streetAddress", e.target.value)} placeholder="Street address" />
        </div>
        <div style={{ ...s.fieldGrid3, marginTop: 14 }}>
          <div style={s.fieldGroup}>
            <label style={s.label}>Suburb</label>
            <input style={s.input} value={form.suburb} onChange={(e) => u("suburb", e.target.value)} placeholder="Suburb" />
          </div>
          <div style={s.fieldGroup}>
            <label style={s.label}>State</label>
            <input style={s.input} value={form.state} onChange={(e) => u("state", e.target.value)} placeholder="State" />
          </div>
          <div style={s.fieldGroup}>
            <label style={s.label}>Postcode</label>
            <input style={s.input} value={form.postcode} onChange={(e) => u("postcode", e.target.value)} placeholder="Postcode" />
          </div>
        </div>
      </div>

      <hr style={s.divider} />

      {/* ── Company Billing Details ── */}
      <div style={s.section}>
        <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", flexWrap: "wrap", gap: 8 }}>
          <div style={s.sectionLabel}>Company Billing Details</div>
          <label style={{ ...s.label, display: "flex", alignItems: "center", gap: 8, cursor: "pointer" }}>
            <input type="checkbox" checked={sameAsBilling} onChange={(e) => handleSameAsBilling(e.target.checked)} />
            Same as Company Details
          </label>
        </div>
        <p style={{ ...s.label, marginBottom: 12, opacity: 0.6 }}>If there is a Strata Corporation or Different Company for Invoicing</p>
        <div style={s.fieldGrid2}>
          <div style={s.fieldGroup}>
            <label style={s.label}>Company Name</label>
            <input style={s.input} value={form.companyName2} onChange={(e) => u("companyName2", e.target.value)} placeholder="Company name" />
          </div>
          <div style={s.fieldGroup}>
            <label style={s.label}>Trading Name (if applicable)</label>
            <input style={s.input} value={form.tradingName2} onChange={(e) => u("tradingName2", e.target.value)} placeholder="Trading name" />
          </div>
          <div style={s.fieldGroup}>
            <label style={s.label}>ABN</label>
            <input style={s.input} value={form.abn2} onChange={(e) => u("abn2", e.target.value)} placeholder="ABN" />
          </div>
          <div style={s.fieldGroup}>
            <label style={s.label}>Contact Phone</label>
            <input style={s.input} value={form.contactPhone} onChange={(e) => u("contactPhone", e.target.value)} placeholder="Phone" />
          </div>
          <div style={s.fieldGroup}>
            <label style={s.label}>Accounts Contact</label>
            <input style={s.input} value={form.accountsContact} onChange={(e) => u("accountsContact", e.target.value)} placeholder="Contact name" />
          </div>
          <div style={s.fieldGroup}>
            <label style={s.label}>Email</label>
            <input style={s.input} value={form.email2} onChange={(e) => u("email2", e.target.value)} placeholder="Email address" />
          </div>
        </div>
        <div style={{ ...s.fieldFull, marginTop: 14 }}>
          <label style={s.label}>Street Address (for payment remittance)</label>
          <input style={s.input} value={form.streetAddress2} onChange={(e) => u("streetAddress2", e.target.value)} placeholder="Street address" />
        </div>
        <div style={{ ...s.fieldGrid3, marginTop: 14 }}>
          <div style={s.fieldGroup}>
            <label style={s.label}>Suburb</label>
            <input style={s.input} value={form.suburb2} onChange={(e) => u("suburb2", e.target.value)} placeholder="Suburb" />
          </div>
          <div style={s.fieldGroup}>
            <label style={s.label}>State</label>
            <input style={s.input} value={form.state2} onChange={(e) => u("state2", e.target.value)} placeholder="State" />
          </div>
          <div style={s.fieldGroup}>
            <label style={s.label}>Postcode</label>
            <input style={s.input} value={form.postcode2} onChange={(e) => u("postcode2", e.target.value)} placeholder="Postcode" />
          </div>
        </div>
      </div>

      <hr style={s.divider} />

      {/* ── Owners Corporation Split ── */}
      <div style={s.section}>
        <div style={s.sectionLabel}>Owners Corporation Split for Services</div>
        <p style={{ ...s.label, marginBottom: 12, opacity: 0.6 }}>Enter decimal values for percentage (e.g. 0.12 = 12%, 1.0 = 100%)</p>
        <div style={{ overflowX: "auto" }}>
          <table style={s.table}>
            <thead>
              <tr>
                <th style={s.th}>OC Num</th>
                <th style={s.th}>Total-%</th>
                <th style={s.th}>Services</th>
                <th style={s.th}>Consumables</th>
                <th style={s.th}>Periodicals</th>
                <th style={s.th}>Special</th>
              </tr>
            </thead>
            <tbody>
              {OC_ROWS.map((num) => (
                <tr key={num}>
                  <td style={s.tdFirst}>OC-{num}</td>
                  <td style={{ ...s.td, fontWeight: 600 }}>{calcRowTotal(num)}</td>
                  <td style={s.td}>
                    <input style={s.qtyInput} value={form[`oc${num}Services`]} onChange={(e) => u(`oc${num}Services`, e.target.value)} placeholder="0.00" />
                  </td>
                  <td style={s.td}>
                    <input style={s.qtyInput} value={form[`oc${num}Consumables`]} onChange={(e) => u(`oc${num}Consumables`, e.target.value)} placeholder="0.00" />
                  </td>
                  <td style={s.td}>
                    <input style={s.qtyInput} value={form[`oc${num}Periodicals`]} onChange={(e) => u(`oc${num}Periodicals`, e.target.value)} placeholder="0.00" />
                  </td>
                  <td style={s.tdLast}>
                    <input style={s.qtyInput} value={form[`oc${num}Special`]} onChange={(e) => u(`oc${num}Special`, e.target.value)} placeholder="0.00" />
                  </td>
                </tr>
              ))}
              <tr>
                <td style={{ ...s.tdFirst, fontWeight: 700 }}>Total-%</td>
                <td style={{ ...s.td, fontWeight: 700 }}>{calcGrandTotal()}</td>
                <td style={{ ...s.td, fontWeight: 700 }}>{calcColTotal("Services")}</td>
                <td style={{ ...s.td, fontWeight: 700 }}>{calcColTotal("Consumables")}</td>
                <td style={{ ...s.td, fontWeight: 700 }}>{calcColTotal("Periodicals")}</td>
                <td style={{ ...s.tdLast, fontWeight: 700 }}>{calcColTotal("Special")}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <hr style={s.divider} />

      {/* ── EOM Invoice ── */}
      <div style={s.section}>
        <div style={s.sectionLabel}>EOM Invoice</div>
        <div style={s.fieldFull}>
          <label style={s.label}>Email Address for Billing</label>
          <input style={s.input} value={form.eomInvoice} onChange={(e) => u("eomInvoice", e.target.value)} placeholder="billing@example.com" />
        </div>
      </div>

      <div style={s.btnRow}>
        <button style={downloadBtnStyle(isValid)} onClick={handleDownload} disabled={!isValid || downloading}>
          {downloading ? (<><span style={s.spinner} /> Generating PDF...</>) : (<><DownloadIcon /> Download Filled PDF</>)}
        </button>
        <button style={s.resetBtn} onClick={handleReset}>Reset</button>
      </div>
      {error && <div style={s.error}>{error}</div>}
    </div>
  );
};

export default VendorCreationForm;